import React, { Component } from 'react'
import { Col, Row, Label } from 'reactstrap'
import ModalForm from '../../../../comum/components/ModalForm'
import RadiobuttonGroup from '../../../../comum/components/RadiobuttonGroup'
import FormDatePicker from '../../../../comum/components/FormDatePicker'
import { observer } from 'mobx-react'
import CifStore from '../stores/CifStore'
import FormInputSimples from '../../../../comum/components/FormInputSimples'
import LoadingImage from '../../../../comum/components/LoadingImage'
import moment from 'moment';
import FormInputCurrency from '../../../../comum/components/FormInputCurrency'
import NumberFormat from 'react-number-format'

@observer
export default class ModalDadosCIF extends Component {

    constructor(props) {
        super(props);

        this.importController = this.props.controller;
        this.controller = new CifStore(this.props.controller.service, this.props.controller.blDiInfo.ValorReal,this.props.controller.blDiInfo.ValorDolar );

        this.handleSalvar = this.handleSalvar.bind(this);

        this.controller.dataSaidaCarga = moment();

        let obrigatorio = (this.controller.valorCIF === undefined || !this.controller.valorCIF || this.controller.valorCIF === 0);
        this.importController.setDIObrigatorio(obrigatorio);
    }

    handleSalvar() {
        if (this.validar())
        {
            this.controller.calcular = true;
            let valorCIFFinal;
            if(this.controller.valorCIFReal !== null) {
                valorCIFFinal = this.controller.valorCIF;
            } else {
                valorCIFFinal = this.controller.valorCIF.replace("R$","").replace(/\./g,"").replace(",",".")
            }
            if(!this.alertaCIF() && this.controller.calcular) {
                this.importController.calcular(moment(this.controller.dataSaidaCarga).format("YYYY-MM-DD"), "", this.controller.moedaSelecionada, valorCIFFinal);
            }
            //this.importController.fecharModalCalculo();
        }
    }

    validar = () => {
        if (!this.controller.valorCIF)
        {
            return false
        }
        if (this.importController.dataDIObrigatorio && !this.controller.dataRI)
        {
            return false
        }
        return true
    }

    alertaCIF() {
        return this.importController.valorCIF === null ? "Campo obrigatório" : null;
    }

    render() {
        return (
            <ModalForm
                onClickCancelar={this.importController.fecharModalCalculo}
                onClickSalvar={this.handleSalvar}
                labelConfirmar="CALCULAR"
                salvando={this.importController.loadingCalcular || this.importController.loadingExibirOS}
                className="tamanho-modal-500"
                habilitaSalvar={this.validar()}
            >
                <h2>Calcular</h2>
                <Row>
                    {
                        this.controller.loadingMoedas
                        ?<Row className="w-100"><Col xs={12} sm={12} md={12} lg={12} xl={12}><LoadingImage /></Col></Row>
                        :<RadiobuttonGroup
                            xs={12} sm={12} md={12} lg={12} xl={12}
                            titulo="Tipo de orçamento"
                            name="moeda"
                            onClick={(event) => this.controller.setMoeda(event.target.value)}
                            itens={this.controller.moedas}
                        />
                    }
                </Row>
                <Row>
                    <FormDatePicker xs={12} sm={12} md={6} lg={6} xl={6}
                        titulo="Estimativa de fim de serviço"
                        date={this.controller.dataSaidaCarga}
                        onChange={this.controller.setDataSaidaCarga}
                    />
                    {this.controller.valorCIFReal === null &&
                    <FormDatePicker xs={12} sm={12} md={6} lg={6} xl={6}
                        titulo="Data de registro da DI"
                        date={this.controller.dataRI}
                        alerta={this.importController.dataDIObrigatorio && !this.controller.dataRI ? "Informar a data de registro da DI":""}
                        onChange={this.controller.setDataRI}
                    />}
                    <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Label>
                            Valor CIF
                        </Label>
                        <NumberFormat
                            style={{padding:"11px 6px", width:"100%"}}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalPrecision={2}
                            decimalSeparator=","
                            prefix="R$"
                            value={this.controller.valorCIF}
                            onChange={(event) => this.controller.setValorCif(event.target.value)}
                            disabled={this.controller.valorCIFReal !== null}
                        />
                        {!this.controller.valorCIF && <Label className="mt-1 label-danger"> Informar o valor CIF</Label>}
                    </Col>
                </Row>
            </ModalForm>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/importacao/components/ModalDadosCIF.js